import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

import { FileModelSchema } from '../schemas/FileModel';

// No PathParameters

// No QueryParameters

// No RequestBody

const ResponseDataSchema = z.array(z.lazy(() => FileModelSchema));
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(): Promise<Optional<ResponseData>> {
	const url: string = SERVICEBASEURL.REPORT + `/v1/files/list`;
	return (await axios.get(url).toOptionalFiltered(validator)).map((x) => x.data);
}
